//import LectureDataFunc from "@/pcomponents/common/content/edu/lecture/func/data";

class LectureDataFunc
{
  static default_lecture_row_data={
    "a_seq": "",
    "a_name": "",
    "a_main_teacher": "",
    "a_main_teacher_seq": "",
    "a_state": "ing",
    "a_period_sort": "month",
    "a_subject": "",
    "a_start_date": "",
    "a_end_date": "",
    "a_room_name": "",
    "a_room_seq": "",
    "a_target_stu_start": "",
    "a_target_stu_end": "",
    "a_max_stu": "20",
    "a_material": "",
    "a_basic_h": "13",
    "a_basic_m": "00",
    "a_basic_length_sec": 60 * 60,
    "a_basic_row_cnt": "1",
    "a_same_days_week": "1,2,3,4,5",
    "a_memo": "",
    "a_order_num": "0",
    "time_arr": [],
  };
}
export default LectureDataFunc;